const errorLog = {
  namespaced: true,
  state: {
    errors: [],
  },
  mutations: {
    ADD_ERROR: (state, err) => {
      if (state.errors.some((it) => it === err)) return;
      state.errors.push(err);
    },
  },
  actions: {
    addError({ commit }, err) {
      if (err instanceof Error && ['BusinessError', 'SystemError'].indexOf(err.name) === -1) {
        commit('ADD_ERROR_LOG', err);
      }
    },
  },
};

export default errorLog;
